import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Login from '../pages/Login';

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // If returning from OAuth callback, allow children to render (rare edge case)
  if (typeof window !== 'undefined' && location.state?.user) {
    return children;
  }

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-[#e11d2c] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) return <Login />;
  if (requireAdmin && user.role !== 'admin') {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-center px-5">
        <div>
          <div className="font-display text-3xl font-bold">Access denied</div>
          <p className="text-black/55 mt-3">Your account isn’t authorized as an admin. Please contact your manager.</p>
        </div>
      </div>
    );
  }
  return children;
}
